import { z } from 'zod';
import { languageSchema } from './language';
import { siteCodeSchema } from './sites';
import { userRoleSchema } from './user-roles';

// App-side user profile — Cognito -> identity/auth; this model -> preferences/app data
export const userProfileSchema = z.object({
  id: z.string(), // Cognito sub
  fullName: z.string(),
  role: userRoleSchema,
  siteLanguage: languageSchema.nullable().default(null),
  selectedSite: siteCodeSchema.nullable().default(null),
  favoriteLocation: z.string().min(1).max(30).nullable().default(null),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});
export type UserProfile = z.infer<typeof userProfileSchema>;

// TODO: This can only be donedd by admin
export const userProfileUpdateSchema = z
  .object({
    siteLanguage: userProfileSchema.shape.siteLanguage.unwrap(),
    selectedSite: userProfileSchema.shape.selectedSite.unwrap(),
    favoriteLocation: userProfileSchema.shape.favoriteLocation,
  })
  .partial();
export type UserProfileUpdate = z.infer<typeof userProfileUpdateSchema>;
